import axios from "axios";

export const read = async (skip,query, searchThis) => {
    try{
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listKontrak?skip=${skip}&query=${query}&searchThis=${searchThis}`,{
        })
    } catch(error){
        throw new Error(error);
    }
}

export const readKontrak = async (skip,query, searchThis) => {
    try{
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listKontrak?skip=${skip}&query=${query}&searchThis=${searchThis}`,{
        })
    } catch(error){
        throw new Error(error);
    }
}